module.exports = __webpack_public_path__ + "static/media/upload-img.56c413f7.svg";